/* StatsBar */
import { STATS } from '../data/content';
import './StatsBar.css';
export default function StatsBar() {
  return (
    <div className="stats-bar">
      {STATS.map(s => (
        <div key={s.label} className="stat">
          <div className="stat__n">{s.number}</div>
          <div className="stat__l">{s.label}</div>
        </div>
      ))}
    </div>
  );
}
